import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'
import Navlink from '../Navlink';
import { URL } from '../BackendApi';
import './style.scss';

import logoInverted from './logo_inverted.png';

// Global footer. Structure and Finnish copy follow the SEO spec (Aug 2026):
// h2 brand heading with the keyword "vartiointiliike", h3 for the two
// sections, h4 per region, <address> only for postal details, legal operator
// in the bottom row. Rendered as a native <footer>, outside <main>.
const OFFICES = [
  {
    heading: 'Pääkaupunkiseutu: Espoo, Helsinki ja Vantaa',
    address: ['Säterin Portti', 'Linnoitustie 6', '02600 Espoo'],
    serviceArea: 'Palvelemme Espoossa, Helsingissä, Vantaalla ja koko pääkaupunkiseudulla.'
  },
  {
    heading: 'Pirkanmaa: Tampere ja lähialueet',
    address: ['Puutarhakatu 33', '33210 Tampere'],
    serviceArea: 'Palvelemme Tampereella, Pirkkalassa, Kangasalla, Ylöjärvellä ja koko Pirkanmaan alueella.'
  },
  {
    heading: 'Varsinais-Suomi: Turku ja lähialueet',
    address: ['Saippua Center', 'Ruissalontie 12 C', '20200 Turku'],
    serviceArea: 'Palvelemme Turussa, Kaarinassa, Raisiossa, Naantalissa ja koko Varsinais-Suomen alueella.'
  }
];

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navigation: [],
      navigationLoading: true
    };
  }

  componentDidMount() {
    this.fetchNavigation();
  }

  fetchNavigation() {
    fetch(`${URL}/pages/navigation`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Failed to fetch navigation');
      })
      .then(data => {
        this.setState({
          navigation: data.navigation || [],
          navigationLoading: false
        });
      })
      .catch(error => {
        console.error('Error fetching footer navigation:', error);
        this.setState({
          navigation: [],
          navigationLoading: false
        });
      });
  }

  renderNavigationItem = (item, index) => {
    return (
      <li key={index} className="link">
        <Navlink to={item.url}>
          {item.title}
        </Navlink>
      </li>
    );
  }

  render() {
    const year = new Date().toLocaleString('en-US', { timeZone: 'Europe/Helsinki', year: 'numeric' });

    return (
      <footer className="site-footer" aria-labelledby="footer-heading">
        <Container fluid className="footer">
          <Container>
            <div className="footer-columns upper">

              <div className="footer-col footer-about">
                <img src={logoInverted} alt="Nordic Security Alliance" className="logo" />
                <h2 id="footer-heading">Nordic Security Alliance – kotimainen vartiointiliike</h2>
                <p>
                  Nordic Security Alliance on kotimainen turvallisuusalan konserni, joka tarjoaa
                  vartiointia, järjestyksenvalvontaa, turvallisuuden asiantuntijapalveluita ja
                  turvallisuusalan koulutuksia koko Suomessa.
                </p>
              </div>

              <section className="footer-col footer-offices" aria-labelledby="footer-offices-heading">
                <h3 id="footer-offices-heading">Toimipisteet ja palvelualueet</h3>

                {OFFICES.map((office) => (
                  <div className="office-item" key={office.heading}>
                    <h4>{office.heading}</h4>
                    <address>
                      {office.address.map((line, i) => (
                        <React.Fragment key={line}>
                          {line}{i < office.address.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </address>
                    <p className="office-service-area">{office.serviceArea}</p>
                  </div>
                ))}

                <p className="footer-email">
                  <a href="mailto:toimisto@nordicsec.fi">toimisto@nordicsec.fi</a>
                </p>
              </section>

              <section className="footer-col footer-nationwide" aria-labelledby="footer-nationwide-heading">
                <h3 id="footer-nationwide-heading">Palvelemme koko Suomessa</h3>
                <p>
                  Palvelemme yrityksiä, julkisen sektorin toimijoita ja muita asiakkaita
                  valtakunnallisesti. Paikallisia yhteyshenkilöitämme on muun muassa
                  Jyväskylässä, Oulussa, Vaasassa, Lahdessa, Joensuussa, Seinäjoella ja Porissa.
                </p>
                <p>
                  <Navlink to="/yhteystiedot">Katso alueelliset yhteyshenkilöt ja kaikki yhteystiedot</Navlink>
                </p>
                <p className="footer-badges">
                  <a href="https://zeckit.com/selvitys/FI/2406929-9?section=quickcheck" rel="noopener noreferrer" target="_blank">
                    <img src="https://www.vastuugroup.fi/hubfs/VG-website/luotettava-kumppani-logo-vihrea.png" alt="Luotettava Kumppani" width="227" loading="lazy" />
                  </a>
                </p>
                <p>
                  <a href="https://intra.nordicsec.fi" target="_blank" rel="noopener noreferrer" className="btn-blue">Intra</a>
                </p>
              </section>
            </div>

            <div className="footer-bottom lower">
              <nav className="footer-nav-wrap" aria-label="Sivuston alatunnisteen navigaatio">
                <ul className="footer-nav">
                  {this.state.navigationLoading ? (
                    <li className="link">Loading...</li>
                  ) : (
                    this.state.navigation.map((item, index) => this.renderNavigationItem(item, index))
                  )}
                  <li className="link"><Navlink to="/tietosuojaseloste">Tietosuojaseloste</Navlink></li>
                  <li className="link"><Navlink to="/evastekaytanto">Evästekäytäntömme</Navlink></li>
                </ul>
              </nav>
              <p className="footer-legal">
                &copy; {year} Nordic Security Alliance Group Oy · Y-tunnus: 2840153-5
              </p>
            </div>
          </Container>
        </Container>
      </footer>
    );
  }
}

export default Footer;
